/* =========================================================================
   SAMSARA — SECTION-HOME-PHILOSOPHY.JS
   Sprint 6 polish rebuild 2026-05-19. Pause rotate animation when offscreen.

   Logic minimă: IntersectionObserver toggle `.is-visible` pe section root.
   CSS porneste animation doar pe .is-visible (animation-play-state: running).
   Desktop-only — pe mobile mandala e display:none, nu trebuie observer.
   ========================================================================= */

(function () {
  'use strict';

  function boot() {
    const sections = document.querySelectorAll('.home-philosophy');
    if (!sections.length) return;
    if (!window.matchMedia('(min-width: 1024px)').matches) return; // desktop-only
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0 });

    sections.forEach(function (s) { observer.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
